import axiosInstance from "./axiosInstance";
import { clearTokens } from "../../utils/storage";
import Swal from 'sweetalert2';

export const login = async (formData) => {
  let response;
  try {
    response = await axiosInstance.post(
      "/auth/login",
      formData,
      { headers: { authType: "PreLogin" } }
    );
  
    localStorage.setItem('companyId',response.data.companyId);
    localStorage.setItem('userId',response.data.userId);
    localStorage.setItem('userType',response.data.userType);
    localStorage.setItem('roles',response.data.roles);
    //  if (response.data.userType==='PATIENT') {
    //   //navigate("/");
    //   const destination = from.pathname || from;
    // navigate(destination, { replace: true });
    // }
    //  else {
    // localStorage.removeItem('accessToken');
    // localStorage.removeItem('refreshToken');
    // localStorage.removeItem('companyId');
    // localStorage.removeItem('roles');
    // localStorage.removeItem('userId');
    // localStorage.removeItem('userType');
    // localStorage.removeItem('titles');
   
    // Swal.fire({
    //           title: 'Failed!',
    //           text: `Wrong Credentials`,
    //           icon: 'error',
    //           confirmButtonColor: '#566fe2',
    //           customClass: {
    //             title: 'swal-title-small',
    //             popup: 'swal-popup-small',
    //             confirmButton: 'swal-button-small'
    //           }
    //         });
    // }
    if (response.data.userType !== 'PATIENT') {
      clearTokens();
      localStorage.clear();   // clear everything for non-patient
      Swal.fire({ title: 'Failed!', text: 'Only patients are allowed', icon: 'error',});
      throw new Error("Only patients allowed");
    }

    return response.data;
  } catch (error) {
     const textRes=response.data.message;
    Swal.fire({
              title: 'Failed!',
              text: textRes,
              icon: 'error',
              confirmButtonColor: '#566fe2',
              customClass: {
                title: 'swal-title-small',
                popup: 'swal-popup-small',
                confirmButton: 'swal-button-small'
              }
            });
    console.error("Login error:", {
      
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw new Error(error.response?.data?.token || "Login failed. Please check your credentials.");
  }
};

export const signUp = async (formData) => {
  let response;
  try {
    response = await axiosInstance.post(
      "/auth/sign-up-patients",
      formData,
      { headers: { authType: "PreLogin" } }
    );
   
    return response;
  } catch (error) {
     const textRes=response.data.data;
    Swal.fire({
              title: 'Failed!',
              text: textRes,
              icon: 'error',
              confirmButtonColor: '#566fe2',
              customClass: {
                title: 'swal-title-small',
                popup: 'swal-popup-small',
                confirmButton: 'swal-button-small'
              }
            });
    console.error("Login error:", {
      
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw new Error(error.response?.data?.token || "Creation failed. Please check your credentials.");
  }
};

export const refreshToken = async () => {
  try {

    const response = await axiosInstance.post(
      "/auth/refresh",
      {},
      { headers: { authType: "PreLogin" } }
    );

    return response.data;
  } catch (error) {
    clearTokens();
    throw new Error(error.response?.data?.token || "Token refresh failed");
  }
};

export const logout = async () => {
  try {
    
      const response = await axiosInstance.post(
        "/auth/logout",
        {},
        { headers: { authType: "PostLogin" } }
      );
      console.log(response);
    
    clearTokens();
    Swal.fire({
  icon: "success",
  title: "Logout",
  text: "Logeed out successfully.",
});
    return { message: "Logout successful" };
  } catch (error) {
    console.error("Logout error:", error.message);
    clearTokens();
    throw new Error(error.response?.data?.token || "Logout failed");
  }
  finally {
    // Always clear local metadata regardless of server success
    localStorage.clear();
  }
};

export const verifyAuth = async () => {
  try {
    const response = await axiosInstance.get("/auth/verify", {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Verification failed");
  }
};

export const loginWithOtp = async (userName, otp) => {
  const response = await axiosInstance.post(
    "/auth/login-otp",
    { userName, otp },
    { headers: { authType: "PreLogin" } }
  );
  localStorage.setItem('companyId', response.data.companyId);
  localStorage.setItem('userId',    response.data.userId);
  localStorage.setItem('userType',  response.data.userType);
  localStorage.setItem('roles',     response.data.roles);

  if (response.data.userType !== 'PATIENT') {
    clearTokens();
    localStorage.clear();
    Swal.fire({ title: 'Failed!', text: 'Only patients are allowed', icon: 'error' });
    throw new Error("Only patients allowed");
  }
  return response.data;
};

